import React, { useState } from "react";
import classes from "./NewPassword.module.css";
import bigcirlce from "../../Assets/bigcircle.svg";
import smallcirlce from "../../Assets/smallcircle.svg";
import promix from "../../Assets/Promix.svg";
import smallsquare from "../../Assets/smallsquare.svg";
import bigsquare from "../../Assets/bigsquare.svg";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg";
import { Link } from "react-router";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Components/API/Api";

const ConfirmPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleResetPassword = async () => {
    if (!email || !password || !confirmPassword) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire("Error", "Passwords do not match", "error");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/v1/reset_password`, {
        email,
        password,
        confirm_password: confirmPassword,
      });

      console.log("Reset Response:", response.data);

      if (response.data?.status) {
        Swal.fire("Success", response.data.message || "Password reset successful", "success");
        setTimeout(() => {
          window.location.href = "/login"; // redirect to login page
        }, 2000);
      } else {
        Swal.fire("Error", response.data?.message || "Reset failed", "error");
      }
    } catch (error) {
      console.error("Reset Error:", error);
      Swal.fire("Error", error.response?.data?.message || error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.main}>
      <div className={classes.leftside}>
        <img src={bigcirlce} className={classes.paint} />
        <img src={smallcirlce} className={classes.point} />

        <div className={classes.grit}>
          <img src={promix} className={classes.pro} />
          <p className={classes.fir_txt}>Smart Accounting for Nigerian Businesses</p>
          <p className={classes.sec_txt}>
            Reset your password securely and regain access to your account
          </p>

          <img src={smallsquare} className={classes.bi_squ} />
          <img src={bigsquare} className={classes.sm_squ} />
        </div>
      </div>

      <div className={classes.right}>
        <div className={classes.protw}>
          <p className={classes.cre_top}>Reset Password</p>
          <p className={classes.adkt}>Enter your new password below</p>
        </div>

        <div className={classes.portned} onKeyDown={(e) => e.key === "Enter" && handleResetPassword()}>
          <div className={classes.james}>
            <label>Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              className={classes.print}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className={classes.james}>
            <label>New Password</label>
            <div className={classes.portal}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Create a strong password"
                className={classes.print}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <img
                src={showPassword ? eyesoff : eye}
                alt="Toggle visibility"
                className={classes.eye}
                onClick={() => setShowPassword((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          <div className={classes.james}>
            <label>Confirm Password</label>
            <div className={classes.portal}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Confirm your password"
                className={classes.print}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <img
                src={showPassword ? eyesoff : eye}
                alt="Toggle visibility"
                className={classes.eye}
                onClick={() => setShowPassword((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>

        <button
          className={classes.sign}
          onClick={handleResetPassword}
          disabled={loading}
        >
          {loading ? <span className={classes.spinner}></span> : "Reset Password"}
        </button>

        <p className={classes.rec}>
          Remembered your password?{" "}
          <Link to="/signin">
            <span className={classes.cptue}>Sign in</span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ConfirmPassword;
